import script from "./TemplateList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateList.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateList.vue?vue&type=style&index=0&id=e791acd8&scoped=true&lang=less"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e791acd8"]])

export default __exports__